import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const constantRouterMap = [
    {path: '/zslogin', component: () => import('@/views/Login.vue'), name: '哲水', hidden: false},
    {path: '/yzlogin', component: () => import('@/views/Login.vue'), name: '颐酌', hidden: false},
    {path: '/kllogin', component: () => import('@/views/Login.vue'), name: '琨伦', hidden: false},
    {path: '/hclogin', component: () => import('@/views/Login.vue'), name: '慧车', hidden: false},
    {path: '/404', component: () => import('@/views/404.vue'), name: '404', hidden: false},
    {path: '/', component: () => import('@/views/Home.vue'), name: 'Home', hidden: false},
    // {
    //     path: '/',
    //     component: () => import('@/views/Home.vue'),
    //     name: '系统设置',
    //     redirect: '/personal',
    //     children: [
    //         { path: '/personal', component: () => import('@/views/systemManage/personal.vue'), name: '个人中心', meta: {permission: []} }
    //     ]
    // }
]
export const constantWhiteRouterMap = [
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '系统设置',
        redirect: '/personal',
        children: [
            {
                path: '/personal',
                component: () => import('@/views/systemManage/personal.vue'),
                name: '个人中心',
                meta: {permission: []}
            }
        ]
    }
]
export default new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})
export const asyncRouterMap = [
    {
        path: '/login',
        component: () => import('@/views/Login.vue'),
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/404.vue'),
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '机构',
        leaf: true,//只有一个节点
        redirect: '/orgination',
        children: [
            {
                path: '/orgination',
                component: () => import('@/views/orgnizationQuery'),
                name: '机构查询',
                hidden: true,
                meta: {permission: []}
            },
            {
                path: 'orgination/servicePrice/:sourceCode',
                component: () => import('@/views/orgnizationQuery/servicePrice'),
                name: '机构服务价格管理',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '网点',
        leaf: true,//只有一个节点
        redirect: '/networkQuery',
        children: [
            {
                path: '/networkQuery',
                component: () => import('@/views/networkQuery'),
                name: '网点查询',
                props: {name: '网点查询'},
                hidden: true,
                meta: {permission: []}
            }
        ]
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '查询',
        leaf: true,//只有一个节点
        redirect: '/orderQuery',
        children: [
            {
                path: '/orderQuery',
                component: () => import('@/views/orderQuery'),
                name: '订单查询',
                hidden: true,
                meta: {permission: []}
            }
        ],
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '订单',
        leaf: true,//只有一个节点
        redirect: '/orderCenter',
        children: [
            {
                path: '/orderCenter',
                component: () => import('@/views/orderCenter'),
                name: '订单中心',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '核销',
        leaf: true,//只有一个节点
        redirect: '/couponVerification',
        children: [
            {
                path: '/couponVerification',
                component: () => import('@/views/couponVerification'),
                name: '核销',
                hidden: true,
                meta: {permission: []}
            }
        ]
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '券码',
        leaf: true,//只有一个节点
        redirect: '/couponActivation',
        children: [
            {
                path: '/couponActivation',
                component: () => import('@/views/couponActivation'),
                name: '券码激活',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '导入',
        leaf: true,//只有一个节点
        redirect: '/orderImport',
        children: [
            {
                path: '/orderImport',
                component: () => import('@/views/orderImport'),
                name: '订单导入',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '财务数据',
        leaf: true,//只有一个节点
        redirect: '/financialData',
        children: [
            {
                path: '/financialData',
                component: () => import('@/views/financialData'),
                name: '财务管理',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '服务',
        leaf: true,//只有一个节点
        redirect: '/servicePacksImport',
        children: [
            {
                path: '/servicePacksImport',
                component: () => import('@/views/servicePacksImport'),
                name: '服务包导入',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '供应商',
        leaf: true,//只有一个节点
        redirect: '/supplierManage',
        children: [
            {
                path: '/supplierManage',
                component: () => import('@/views/supplierManage'),
                name: '供应商管理',
                hidden: true,
                meta: {permission: []}
            },
            {
                path: 'supplierManage/servicePrice/:supplierCode',
                component: () => import('@/views/supplierManage/servicePrice'),
                name: '供应商服务价格管理',
                hidden: true,
                meta: {permission: []}
            }
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '系统设置',
        // 2023.02.27需求默认跳转到订单页
        redirect: '/orderCenter',
        children: [
            {
                path: '/account',
                component: () => import('@/views/systemManage/account.vue'),
                name: '账号管理',
                meta: {permission: []}
            },
            {
                path: '/menuManagement',
                component: () => import('@/views/systemManage/account.vue'),
                name: '菜单管理',
                meta: {permission: []}
            },
            {
                path: '/personal',
                component: () => import('@/views/systemManage/personal.vue'),
                name: '个人中心',
                meta: {permission: []}
            },
            {
                path: '/serviceSts',
                component: () => import('@/views/systemManage/serviceSts.vue'),
                name: '订单状态维护',
                meta: {permission: []}
            },
        ],
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/views/Home.vue'),
        name: '券码查询',
        redirect: '/coupon',
        leaf: true,//只有一个节点
        children: [
            {
                path: '/coupon',
                component: () => import('@/views/coupon'),
                name: '券码查询',
                meta: {}
            },
        ],
        hidden: true
    },
    {path: '*', redirect: '/404', hidden: true}
]

// export default routes;



// WEBPACK FOOTER //
// ./src/routes.js